import React, {lazy, Suspense} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {AUTH, CATEGORY_FOOD, CHARTS, COMMERCE, DARK_STORE, MAIN, MAP, NEWS, SKU_FOOD} from "../../common/constants";
import {Auth} from "../../pages/auth";
import {Main} from "../../pages/main";
import {ChartsPage} from "../../pages/chartsPage";
import {MapInfoPointPage} from "../../pages/mapPage/mapInfoPointPage";
import {News} from "../../pages/news";
import {DarkStorePage} from "../../pages/darkStorePage";
import {SkuFood} from "../../pages/skuFood";
import {CategoryFood} from "../../pages/categoryFood";
import {CommercePage} from "../../pages/commerce";


const MapPage= lazy(() => import("../../pages/mapPage")
    .then(({ MapPage }) => ({ default: MapPage })),
)


export const RoutesComponent = () => {

    return (
        <div>
            <Routes>
                <Route path={AUTH} element={<Auth/>}/>
                <Route path={MAIN} element={<Main/>}>
                    <Route path={MAIN} element={<Navigate to={CHARTS}/>}/>
                    <Route path={CHARTS} element={<ChartsPage/>}/>
                    <Route path={COMMERCE} element={<CommercePage/>}/>
                    <Route path={NEWS} element={<News/>}/>
                    <Route path={DARK_STORE} element={<DarkStorePage/>}/>
                    <Route path={SKU_FOOD} element={<SkuFood/>}/>
                    <Route path={CATEGORY_FOOD} element={<CategoryFood/>}/>
                    <Route path={MAP} element={<Suspense fallback={<div>loading</div>}><MapPage/></Suspense>}/>
                    <Route path={`${MAP}/:id`} element={<MapInfoPointPage/>}/>
                </Route>
            </Routes>
        </div>
    );
};

